import { Component } from '@angular/core';
import { CXoneVoiceContact } from '@nice-devone/acd-sdk';
import { OpenIdService } from '@quickweb/authenticator-angular';
import { LoggerService } from 'src/app/core/services/logger.service';
import { LoginService } from 'src/app/core/services/login.service';
import { UtilService } from 'src/app/core/services/util.service';
import { SdkAcdAgent } from 'src/app/data/CXOne/sdk-acd/sdk-acd.service';
import { NiceSdkAuthenticationService } from 'src/app/data/CXOne/sdk-auth/nice-sdk-authentication.service';
import { EventHandlerService } from 'src/app/data/services/event-handler.service';
import { VoiceContactStatusAgent } from 'src/app/shared/enums/voice-contact-status-agent.enum';
import { AgentApiService } from 'src/app/shared/services/agent-api-service';
import { GenericModalService } from 'src/app/shared/services/generic-modal.service';

import { timeout } from 'rxjs/operators';

@Component({
  selector: 'app-itau-shop',
  standalone: true,
  imports: [],
  templateUrl: './itau-shop.component.html',
  styleUrl: './itau-shop.component.css',
})
export class ItauShopComponent {
  loggerTag = 'ITAU-SHOP ';
  ErrorTitleMsg = 'Ocorreu um erro ao criar o ticket na integração';
  constructor(
    private openId: OpenIdService,
    private agentService: AgentApiService,
    private logger: LoggerService,
    private loginService: LoginService,
    private niceSdkAuthService: NiceSdkAuthenticationService,
    private sdkAcdAgent: SdkAcdAgent,
    private eventHandler: EventHandlerService,
    private modalGeneric: GenericModalService,
    private utilService: UtilService,
  ) {}

  async ngOnInit() {
    this.openId.isLoggedIn().subscribe((e) => {
      this.logger.info('Status usuário logado = ', e);
      if (!e) {
        this.openId.signIn();
      }
    });
    let employeeid = '';

    this.openId.checkAuth().subscribe((e) => {
      employeeid = e.userData.employeeid;
    });

    this.logger.info('funcional', employeeid);

    this.logger.info(this.loggerTag + '- inicializado');
    const centralId = localStorage.getItem('centralId') || 'itau-shop';
    const authServiceType = localStorage.getItem('authServiceType') || 'nice';
    const authMode = localStorage.getItem('display_mode') || 'popup';
    try {
      const isAuthenticated = await this.loginService.login(
        authServiceType,
        centralId,
        true,
        authMode,
      );

      if (!isAuthenticated) {
        this.logger.info(this.loggerTag + 'Usuário não autenticado');
        return;
      }

      this.logger.info(this.loggerTag + 'Usuário autenticado');

      await this.niceSdkAuthService.launchAgent();
      await this.sdkAcdAgent.initialize();

      this.sdkAcdAgent.voiceContactUpdate$.subscribe(
        async (voiceContact: CXoneVoiceContact) => {
          this.logger.info(this.loggerTag + 'entrou evento de subscribe');
          const status = voiceContact.status || '';
          const contactId = voiceContact.contactID || '';
          const eventContact = { id: contactId, status: status };
          const processedEvent = this.eventHandler.isProcessed(eventContact);
          this.logger.info(this.loggerTag + 'evento processado.');

          if (status === VoiceContactStatusAgent.ACTIVE && !processedEvent) {
            this.logger.info(this.loggerTag + 'VoiceActive moment');
            this.eventHandler.add(eventContact);
            await this.createItauShopTicket(voiceContact, employeeid);
          }
        },
      );
    } catch (error) {
      this.logger.error(this.loggerTag + '- erro autenticar usuário', error);
      //this.agentService.getTest();
    }
  }

  private async createItauShopTicket(
    voiceContact: CXoneVoiceContact,
    employeeid: string,
  ) {
    try {
      const screenPopUrl = this.sdkAcdAgent.deserializeScreenPopUrl(
        voiceContact.screenPopUrl,
      );
      const attachJson = this.utilService.parseJsonAndReplaceQuotes(
        screenPopUrl.u_json,
      );
      attachJson.EMPLOYEEID = employeeid;
      const attachData = JSON.stringify(attachJson);

      this.logger.info(this.loggerTag + 'attachData -', attachData);

      this.agentService
        .postCreateTicketItauShop(attachData)
        .pipe(timeout(50000))
        .subscribe({
          next: (response) => {
            if (response.status == 200) {
              this.createModal(
                response.body.data[0].mensagem,
                response.body.data[0].idTicketZendesk,
              );
            }
          },
          error: (err) => {
            this.logger.error(err);
            this.createModal(this.ErrorTitleMsg, '');
          },
        });
    } catch (error) {
      this.createModal(this.ErrorTitleMsg, '');
      this.logger.error(
        this.loggerTag + 'erro ao recuperar o attachData',
        error,
      );
      return;
    }
  }

  private createModal(title: string, description: string) {
    this.modalGeneric.createModal({
      title: title,
      description: description,
      allowCloseModal: true,
    });
  }
}
